<script>
import BaseButton from '@/components/lavender/v2/BaseButton.vue'
import LoginFormInputPhone from '@/views/login/components/LoginFormInputPhone.vue'

export default {
  name: 'BodyContentInputPhone',
  components: { BaseButton, LoginFormInputPhone },
  props: {
    submitting: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      phoneNumber: '',
      countryCallingCode: '966',
      errorMessages: {
        phoneNumber: '',
      },
    }
  },
  methods: {
    validatePhoneNumber() {
      this.errorMessages.phoneNumber = ''

      if (!this.phoneNumber) {
        this.errorMessages.phoneNumber = this.$t('phone_number_required')

        return false
      }

      return true
    },
    handleClickedSubmit() {
      if (this.validatePhoneNumber()) {
        this.$emit('submit', {
          phoneNumber: this.phoneNumber,
          countryCallingCode: this.countryCallingCode,
        })
      }
    },
  },
}
</script>

<template>
  <div class="verify-phone-number__body-content__input-phone">
    <div class="content-title">
      {{ $t('add_phone_number_dialog_title') }}
    </div>
    <div class="content-description">
      {{ $t('add_phone_number_dialog_description') }}
    </div>
    <div class="content-input-field">
      <LoginFormInputPhone
        :phone-number.sync="phoneNumber"
        :country-calling-code.sync="countryCallingCode"
        :error-message="errorMessages.phoneNumber || errorMessage"
        @blur:phone-number="validatePhoneNumber"
      />
    </div>
    <div class="content-action">
      <BaseButton
        type="primary"
        :loading="submitting"
        :disabled="submitting"
        track-id="verify_phone_number_submit"
        @click="handleClickedSubmit"
      >
        {{ $t('add_phone_number_dialog_submit_button_label') }}
      </BaseButton>
      <BaseButton
        type="secondary"
        :disabled="submitting"
        track-id="verify_phone_number_cancel"
        @click="$emit('close')"
      >
        {{ $t('add_phone_number_dialog_dismiss_button_label') }}
      </BaseButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_breakpoints';
@import '@/styles/lavender/design.scss';

.verify-phone-number__body-content__input-phone {
  --vertical-elements-spacing: 24px;

  display: flex;
  flex-direction: column;
  gap: 24px;

  .content-title {
    @extend .tamara-heading-large;

    color: var(--tamara-color-functional-grey-dark-2);
  }

  .content-description {
    @extend .tamara-paragraph-medium;

    color: var(--tamara-color-text-secondary);
  }

  .content-action {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  @include breakpoints(md) {
    --vertical-elements-spacing: 32px;
  }
}
</style>
